<template>
    <div>
        <!-- <BannerSwiper /> -->
        <div class="swiper-container swiper-banner">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(startData, index) in dataList" :key="index">
                    <div class="page-banner">
                        <div class="page-banner-content" :class="{'note-banner': startData.try_stage === '第 27 期'}">
                            <div class="content-left">
                                <img style="display: none;" class="logo" src="@/assets/img/logo.png" alt=""/>
                                <img class="left-free" src="@/assets/img/page-home-banner-img1.png" alt=""/>
                                <div class="left-img" :id="'index-banner-img-' + startData.id">
                                    <img :src="startData.banner_pic" alt=""/>
                                </div>
                                <div class="left-img-bg">
                                </div>
                            </div>
                            <div class="content-right">
                                <div class="right-last-title">距离<span>活动结束</span>剩余</div>
                                <div class="right-last-time">
                                    <div class="time-one" v-for="(item,index) in startData.countDownDatas" :key="index">
                                        <p class="num">{{item.value}}</p><span></span>
                                        <p>{{item.name}}</p>
                                    </div>
                                </div>
                                <div class="right-title-new" v-if="startData.try_title">{{startData.try_title.split('：')[0]}}<span>{{startData.try_title.split('：')[1]}}</span>
                                </div>
                                <div class="right-text">{{startData.try_subtitle}}</div>
                                <div style="display: none;" class="right-last" v-if="startData.process_img_pc">
                                    <img style="display: none;" :src="startData.process_img_pc" alt="">
                                </div>
                                <div style="display: none;" class="right-num">
                                    产品数量：{{startData.total}}件　　申请人数：{{startData.applytotal}}人
                                </div>
                                <router-link :to="`/detail/` + startData.id" href="#查看详情">
                                    <a class="lijishenqing">
                                        立即申请>
                                    </a>
                                </router-link>

                                <div class="right-last-coupon" v-if="Object.prototype.toString.call(startData.coupon) === '[object Object]'">
                                    <p class="right-last-coupon-infor">申请试用还可获得{{startData.coupon.coupon_title}}</p>
                                    <img class="coupon" :src="startData.coupon.coupon_image" alt="">
                                </div>
                                <div style="width: 100%;height: 70px;" v-else></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-button-prev" v-if="dataList.length > 1"></div>
            <div class="swiper-button-next" v-if="dataList.length > 1"></div>
        </div>

        <div class="page-list">
            <div class="page-list-content">
                <img src="@/assets/img/page-home-list.png" alt=""/>
            </div>
        </div>
        <div class="page-content">
            <div class="container">

                <!--近期试用-->
                <div class="container-one">
                    <div class="title" v-if="waitData.length > 0">
                        <img src="@/assets/img/page-home-container1-title.png" alt=""/>
                    </div>
                    <template v-if="waitData.length > 0">
                        <home-try-list-swiper :list-data="waitData"></home-try-list-swiper>
                    </template>

                    <div class="title service-try" v-if="serviceData.length > 0">
                        <img src="@/assets/img/fuwushiyong.png" alt=""/>
                    </div>
                    <template v-if="serviceData.length > 0">
                        <home-try-list-swiper :list-data="serviceData" is-service="true"></home-try-list-swiper>
                    </template>
                </div>

                <!--往期试用-->
                <div class="container-two">
                    <div class="title">
                        <img src="@/assets/img/page-home-container2-title.png" alt=""/>
                    </div>
                    <div class="container-nav">
                        <div class="nav-one" :class="{ 'nav-active': item.id == navCateId }"
                             v-for="(item, index) in navCateList" :key="index" @click="chooseNav(item.id)">
                            <p>{{item.cate}}</p>
                        </div>
                    </div>
                    <div class="list" v-if="historyData.length>0">
                        <div class="list-one" v-for="(c_item,subIndex) in historyData" :key="subIndex"
                             :class="{'list-one-padding':!c_item.buy_url}">
                            <div class="list-img">
                                <div class="product-info">
                                    <div class="top-text1">{{c_item.try_stage.replace(/ /g,"")}}</div>
                                    <a :href="c_item.have_selected.report_url" target="_blank">
                                        <div class="right-img">
                                            <img class="" src="@/assets/img/page-home-container2-right.png" alt=""/>
                                        </div>
                                    </a>
                                    <router-link :to="`/detail/` + c_item.id" href="#查看详情" class="top">
                                        <div class="img">
                                            <img :src="c_item.try_pic" alt=""/>
                                        </div>
                                        <div class="list-top-right-box">
                                            <p class="list-title" :title="c_item.try_title">{{ c_item.try_title }}</p>
                                            <p>共 {{c_item.total}} 份 {{c_item.applytotal}} 人申请</p>
                                            <a :href="c_item.buy_url" v-if="navCateId !== '6'" @click.stop class="list-title-btn">一键购买同款</a>
                                        </div>
                                    </router-link>
                                </div>

                                <!--试用报告和试用视频-->
                                <div class="bottom">
                                    <div class="try-report-box" v-if="c_item.report_url">
                                        试用报告
                                    </div>
                                    <report-content :item="c_item.have_selected[0]" :itemid="c_item.id"  v-if="c_item.have_selected.length == 1"></report-content>
                                    <div  v-if="!c_item.have_selected.length" class="no-report">暂无内容</div>
                                    <div class="swiper-container swiper-container-report-item" v-if="c_item.have_selected.length > 1"
                                         :id="'swiper-'+c_item.id">
                                        <div class="swiper-wrapper">
                                            <div class="right swiper-slide" v-for="(report, rIndex) in c_item.have_selected"
                                                 :key='rIndex'>
                                                <report-content :item="report" :itemid="c_item.id"></report-content>
                                            </div>
                                        </div>
                                        <div class="swiper-pagination" slot="pagination" style="bottom: 0;"></div>
                                        <div class="swiper-button-prev" v-if="c_item.have_selected.length > 1"></div>
                                        <div class="swiper-button-next" v-if="c_item.have_selected.length > 1"></div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                     <div class="list-none" v-else>暂无数据</div>
                    <div class="container-two-button" @click="addPage()" v-if="isShowPage">点击查看更多>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "../../node_modules/swiper/dist/css/swiper.css";
    import Swiper from "swiper";
    import {mapState} from "vuex";
    import HomeTryListSwiper from "../components/HomeTryListSwiper";
    import ReportContent from "../components/ReportContent";

    export default {
        name: "page2",
        components: {HomeTryListSwiper, ReportContent},
        data() {
            return {
                swiperBanner: null, // banner
                dataList: [],
                start_date_end: '',//当前试用活动数据结束倒计时
                countDownDatas: [],
                waitData: [],//近期活动数据
                serviceData: [], // 服务试用数据
                navCateList: [],//往期数据分类
                navCateId: '',
                historyData: [],//往期活动数据
                page: 1,
                isShowPage: false,
                swiperGroup: {},
                couponTitle: '',
                couponImg: '',
                pageRecord: {
                    module:'eshop促销活动',
                    category1: '0元试用',
                    category2: '首页',
                    title: '0元试用'
                }
            };
        },
        computed: {
            ...mapState([
                "init",
                "activityRule",
                "liked",
                "userName",
                "userPortrait",
                "newPrice",
                "applyState",
            ]),
        },
        created() {
            this.getData();
            this.getDataCate();
            this.gioPageAction(this.pageRecord);
            this.$store.commit("setPageRecordUrl", "&linksourcemodule=eshop促销活动&category1=0元试用&category2=首页");
        },
        methods: {
            initSwiperBanner(){
                if(this.swiperBanner) return;
                this.swiperBanner = new Swiper('.swiper-banner', {
                    autoplay: {
                        delay : 5000, //自动切换的时间间隔，单位ms
                        disableOnInteraction : false //用户操作swiper之后，是否禁止autoplay
                    },
                    speed: 600,
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: ".swiper-banner .swiper-button-next",
                        prevEl: ".swiper-banner .swiper-button-prev",
                    },
                });
            },
            getData() {
                let that = this
                this.axios.get("/campaigns-b/try/index.php?_c=home&_a=trylist").then((response) => {
                    if (response.data.code == 200) {
                        let d = response.data.data;
                        if (d.start.length > 0) {
                            that.dataList = d.start
                            that.dataList.map(item => {
                                item.countDownDatas = that.formatTime(item.date_end)
                                return item
                            })
                            setInterval(() => {
                                that.dataList.map((item, index) => {
                                    item.countDownDatas = that.formatTime(item.date_end);
                                    this.$set(this.dataList, index, item);
                                    return item
                                })
                            }, 1000 * 30)
                        }
                        if (d.wait.length > 0) that.waitData = d.wait
                        if (d.service.length > 0) that.serviceData = d.service
                        this.$nextTick(()=>{
                            this.initSwiperBanner();
                        });
                    }
                })
                    .catch(function (error) {
                    });
            },
            getDataCate() {
                let that = this
                this.axios.get("/campaigns-b/try/index.php?_c=home&_a=trycate").then((response) => {
                    if (response.data.code == 200) {
                        that.navCateId = response.data.data[0].id
                        that.navCateList = response.data.data
                        that.getDataHistory();
                    }
                })
            },
            getDataHistory() {
                let swiper = this.swiperGroup;
                for (let key in swiper) {
                    this.swiperGroup[key].destroy();
                    delete (this.swiperGroup[key]);
                }
                let that = this
                this.axios.get("/campaigns-b/try/index.php?_c=home&_a=tryhistory&p=" + this.page + "&cate_id=" + this.navCateId).then((response) => {
                    if (response.data.code == 200) {
                        let d = response.data.data;
                        if (d.count > 0) {
                            if (that.page * 4 >= d.count) {
                                that.isShowPage = false
                            } else {
                                that.isShowPage = true
                            }
                        } else {
                            that.isShowPage = false
                        }
                        that.historyData = d.list.map(item => {
                          item.report_url = '';
                          const result = item.have_selected.find((v) => {
                            return v.report_url
                          })
                          if(result) {
                            item.report_url = result;
                          }
                          item.have_selected.sort((a, b) => {
                            return Number(b.video_id) - Number(a.video_id)
                          })
                          return item;
                        })
                        that.initSwiper(d.list);
                    }
                })
            },
            initSwiper(data) {
                data.map(item => {
                    if (item.have_selected && item.have_selected.length > 1) {
                        let mark = '#swiper-' + item.id;
                        this.$nextTick(() => {
                            this.swiperGroup[item.id] = new Swiper(mark, {
                                loop: false,
                                speed: 600,
                                slidesPerView: 'auto',
                                pagination: {
                                    el: ".swiper-pagination",
                                    type: "fraction"
                                },
                              navigation: {
                                nextEl: mark + " .swiper-button-next",
                                prevEl: mark + " .swiper-button-prev",
                              },
                            });
                        });
                    }
                });
            },
            chooseNav(index) {
                this.navCateId = index
                this.page = 1
                this.getDataHistory();
            },
            addPage() {
                this.page = this.page + 1
                this.getDataHistory();
            },
            formatTime(start_date_end) {
                var nowTime = new Date().getTime()
                var date_end = this.getTimestamp(start_date_end)
                var lefttime = parseInt(date_end - nowTime / 1000);
                var d = parseInt(lefttime / (24 * 60 * 60));
                var h = parseInt(lefttime / (60 * 60) % 24);
                var m = parseInt(lefttime / 60 % 60);
                var s = parseInt(lefttime % 60);

                // console.log(nowTime,lefttime,'lefttime',)
                if (lefttime <= 0) {
                    d = h = m = s = 0;
                }
                let countDownDatas = []
                countDownDatas.push({
                    name: '天',
                    value: d
                })
                countDownDatas.push({
                    name: '时',
                    value: h
                })
                countDownDatas.push({
                    name: '分',
                    value: m
                })
                if (lefttime <= 0) {
                    this.$store.commit('setApplyState', 'end');
                    return;
                }
                return countDownDatas;
            },
            getTimestamp(date) {
                date = new Date(date.replace(/-/g, '\/'));
                date = date.getTime();
                return Math.round(date / 1000);
            },
            toUrl(url) {
                window.open(url);
            }
        }
    };
</script>

<style>
    .swiper-container-report-item .swiper-pagination-current {
        color: #0976f1;
    }
</style>

<style lang="scss" scoped>
    .container-one {
        .swiper-container {
            padding-bottom: 35px;
        }
    }


    .page-banner {
        width: 100%;
        height: 403px;
        background: url(~@/assets/img/page-home-banner.png) center center/cover no-repeat;
        background-size: auto 100%;

        .page-banner-content {
            width: 800px;
            margin: 0 auto;
            padding-right: 3%;
            height: auto;
            display: flex;
            justify-content: space-between;

            .content-left {
                .logo {
                    width: 41.4%;
                    margin-left: 27px;
                }

                .left-free {
                    position: absolute;
                    width: 325px;
                    top: 40px;
                }

                .left-img {
                    width: 230px;
                    height: 230px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    bottom: 9px;
                    left: 50px;
                    z-index: 2;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .left-img-bg-img {
                    height: 87.5px;
                    width: 100%;
                }

                .button-left {
                    width: 128px;
                    height: 30px;
                    font-size: 17px;
                    text-align: center;
                    margin: 12px auto 0;
                    color: #fff;
                    line-height: 27px;
                    cursor: pointer;
                    border: 1px solid #ffffff;
                    background: linear-gradient(0deg, #820b06 1%, #b50f08);
                    border-radius: 15px;
                }
            }

            .content-right {
                width: 52%;
                justify-content: flex-end;
                padding-bottom: 10px;

                .right-title {
                    font-size: 27px;
                    line-height: 36px;
                    color: #fff;
                    text-align: center;
                    font-weight: bold;

                    span {
                        color: #db433d;
                    }
                }

                .right-title-new {
                    font-size: 27px;
                    line-height: 36px;
                    color: #e6dbcd;
                    text-align: center;
                    font-weight: bold;
                    margin-top: 20px;
                    white-space: nowrap;
                }

                .lijishenqing {
                    position: relative;
                    left: 25%;
                    width: 170px;
                    height: 38px;
                    font-size: 23px;
                    margin: 12px auto 0;
                    color: #fff;
                    line-height: 38px;
                    text-align: center;
                    background: url(~@/assets/img/lijishenq.png) center center/cover no-repeat;
                    background-size: 100% 100%;
                    padding: 8px 40px;
                }

                .right-text {
                    font-size: 16px;
                    text-align: center;
                    line-height: 25px;
                    color: #fff;
                    margin: 20px auto 40px;
                }

                .right-last {
                    position: relative;
                    width: 98%;
                    height: 66px;
                    margin: 0 auto;
                    padding: 0 5.9%;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;

                    img {
                        width: auto;
                        height: auto;
                        max-width: 100%;
                        max-height: 100%;
                    }

                    .line {
                        position: absolute;
                        left: 5.9%;
                        top: 32px;
                        width: 88.2%;
                        height: 1px;
                        background: #fff;
                    }

                    .last-one {
                        position: relative;
                        width: 8px;
                        height: 8px;
                        margin-top: 28px;
                        background: #fff;
                        border-radius: 50%;

                        p {
                            position: absolute;
                            top: 15px;
                            left: -56px;
                            font-size: 14px;
                            color: #fff;
                            line-height: 16px;
                            text-align: center;
                            width: 120px;
                        }

                        .time {
                            top: -20px;
                        }
                    }
                }

                .right-num {
                    margin: 10px auto 27px;
                    font-size: 12px;
                    color: #fff;
                    align-items: center;
                    line-height: 12px;
                }

                .right-last-title {
                    font-size: 20px;
                    text-align: center;
                    letter-spacing: 0.3em;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 28px;

                    span {
                        font-size: 26px;
                        color: #db433d;
                        font-weight: bold;
                    }
                }

                .right-last-time {
                    margin: 11px auto 0;
                    width: 294px;
                    height: 35px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #ffffff;
                    border-radius: 5px;

                    .time-one {
                        height: 27px;
                        width: auto;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-right: 1px dashed #ffffff;

                        &:last-child {
                            border-right: none;
                        }
                    }

                    p {
                        width: 44px;
                        font-size: 21px;
                        text-align: center;
                        font-weight: bold;
                        color: #ffffff;
                        line-height: 29px;

                        &.num {
                            width: 51px;
                            font-size: 23px;
                        }
                    }

                    span {
                        width: 1px;
                        height: 27px;
                        border-right: 1px dashed #ffffff;
                        opacity: 0.7;
                    }
                }

                .right-last-coupon {
                    margin: 0 auto 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 70px;
                    padding-top: 20px;

                    .right-last-coupon-infor {
                        font-size: 16px;
                        font-weight: bold;
                        color: #ffffff;
                        margin-left: 40px;
                        text-align: center;
                        line-height: 25px;
                    }

                    img {
                        width: 83px;
                        height: 83px;
                    }
                }
            }
        }

        // 特殊处理笔记本
        .note-banner {
            .content-left {
                .left-img {
                    width: 290px;
                    height: 290px;
                    bottom: 40px;
                    left: 23px;
                }
            }
        }
    }

    .page-banner .page-banner-content .content-left,
    .page-banner .page-banner-content .content-right {
        width: 50%;
        height: 403px;
        padding-top: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .page-list {
        width: 100%;
        height: 97px;
        background: #1f334d;
        border-bottom: 1px solid #ccbaa3;
        border-top: 1px solid #ccbaa3;

        .page-list-content {
            width: 95%;
            height: 97px;
            max-width: 800px;
            margin: 0px auto;
            display: flex;
            align-items: center;

            img {
                width: 97%;
            }
        }
    }

    .page-content {
        width: 100%;
        height: auto;
        min-height: calc(100vh - 403px - 97px);
        background: url(~@/assets/img/page-home-bg.png) center center/cover no-repeat;

        .container {
            width: 900px;
            margin: 0 auto;
            padding: 35px 0 50px;

            .container-one {
                width: 100%;
                min-height: 513px;
                margin-bottom: 40px;
                padding: 110px 6.875% 58px;
                height: auto;
                background: url(~@/assets/img/page-home-container1-bg.png) center center/cover no-repeat;
                background-size: 100% 100%;
            }

            .title {
                width: auto;
                height: 47px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 40px;

                img {
                    height: 100%;
                }
            }

            .list {
                display: flex;
                flex-wrap: wrap;
            }

            .container-two {
                width: 100%;
                min-height: 585px;
                padding: 38px 8.125%;
                height: auto;
                background: url(~@/assets/img/page-home-container2-bg.png) center center/cover no-repeat;

                .container-nav {
                    width: 100%;
                    height: 33px;
                    margin: -25px auto 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background-size: 100% 100%;

                    .nav-one {
                        width: 22%;
                        height: 100%;
                        padding: 8px 10px 0;
                        border: 1px solid #243a58;
                        color: #243a58;
                        background-color: #fff;
                        margin-right: 10px;
                        border-radius: 5px;
                        transition: all .3s;

                        &:hover {
                            background-color: #5ea3f4;
                            border: 1px solid #589ae6;

                            p {
                                color: #fff;
                            }
                        }

                        p {
                            font-size: 15px;
                            color: #243a58;
                            text-align: center;
                            line-height: 15px;
                            cursor: pointer;
                            transition: all .3s;
                        }

                        &:last-child {
                            margin-right: 0;
                        }
                    }

                    .nav-active {
                        border: 1px solid #243a58;
                        color: #fff;
                        background-color: #243a58;

                        p {
                            color: #fff;
                        }
                    }
                }

                .list-none {
                    width: 100%;
                    height: 300px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 17px;
                    color: #243a58;
                    line-height: 20px;
                    letter-spacing: 5px;
                }

                .list {
                    margin-top: 20px;

                    .list-one {
                        width: 49.3%;
                        height: auto;
                        margin-right: 1.4%;
                        padding-bottom: 10px;

                        &:nth-child(2n) {
                            margin-right: 0;
                        }

                        .list-img {
                            position: relative;
                            width: 100%;
                            height: 255px;
                            box-shadow: -0.244px -1.985px 11px 0px rgba(2, 42, 107, 0.21);

                            .product-info {
                                height: 120px;
                                background-image: -moz-linear-gradient(0deg, rgb(199, 225, 255) 0%, rgb(255, 255, 255) 69%);
                                background-image: -webkit-linear-gradient(0deg, rgb(199, 225, 255) 0%, rgb(255, 255, 255) 69%);
                                background-image: -ms-linear-gradient(0deg, rgb(199, 225, 255) 0%, rgb(255, 255, 255) 69%);
                                background-image: linear-gradient(0deg, rgb(199, 225, 255) 0%, rgb(255, 255, 255) 69%);
                            }


                            .top-text1 {
                                position: absolute;
                                top: 14px;
                                left: 0;
                                padding-left: 4px;
                                width: 50px;
                                height: 18px;
                                font-size: 10px;
                                color: #ffffff;
                                line-height: 18px;
                                background: url(~@/assets/img/page-home-container1-top-bg.png) center center/cover no-repeat;
                                border-radius: 0 9px 9px 0;
                                z-index: 1;
                            }

                            .top-text2 {
                                position: absolute;
                                top: 8px;
                                right: 0;
                                width: 60px;
                                height: 18px;
                                font-size: 10px;
                                cursor: pointer;
                                text-align: center;
                                color: #ffffff;
                                line-height: 18px;
                                background: url(~@/assets/img/page-home-container2-top-bg.png) center center/cover no-repeat;
                                border-radius: 7px 0 0 7px;
                            }

                            .right-img {
                                position: absolute;
                                top: 0;
                                right: 0;
                                height: 149px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 35px;
                                display: none;

                                img {
                                    width: 13px;
                                }
                            }

                            .left {
                                padding: 10px 10px 0;
                                width: 54%;
                            }

                            .top {
                                padding: 30px 10px 0;
                                display: flex;
                                justify-content: space-around;
                                width: 96%;

                                .img {
                                    position: relative;
                                    top: -10px;
                                    width: 90px;
                                    height: 90px;
                                    margin: 0 auto;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    img {
                                        width: 100%;
                                        height: 100%;
                                    }
                                }

                                p {
                                    font-size: 9px;
                                    text-align: center;
                                    color: #000000;
                                    line-height: 13px;
                                }

                                .list-top-right-box {
                                    margin-left: 20px;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: flex-end;
                                }

                                .list-title {
                                    width: 180px;
                                    text-align: right;
                                    margin: 7px 0 5px auto;
                                    font-size: 10px;
                                    font-weight: 600;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }

                                .list-title-btn {
                                    display: block;
                                    box-sizing: border-box;
                                    background-image: -moz-linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);
                                    background-image: -webkit-linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);
                                    background-image: -ms-linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);
                                    background-image: linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);
                                    height: 25px;
                                    line-height: 25px;
                                    background-size: 100% 100%;
                                    text-align: center;
                                    width: 110px;
                                    color: #fff;
                                    font-size: 13px;
                                    margin-top: 10px;
                                }
                            }

                            .bottom {
                                padding: 25px 10px 0;
                                width: 100%;

                                .no-report{
                                    width: 100%;
                                    height: 100%;
                                    display: flex;
                                    align-content: center;
                                    justify-content: center;
                                    font-size: 20px;
                                    padding-top: 25px;
                                    color:#ccc;
                                }

                                .try-report-box {
                                    position: absolute;
                                    top: 125px;
                                    right: 0;
                                    padding: 0 8px;
                                    font-size: 10px;
                                    height: 18px;
                                    line-height: 18px;
                                    background-color: #d71b13;
                                    color: #fff;
                                    border-top-left-radius: 15px;
                                    border-bottom-left-radius: 15px;
                                }
                                .swiper-container-report-item{
                                    padding-bottom: 15px;

                                  .swiper-button-prev, .swiper-button-next {
                                    position: absolute;
                                    top: auto;
                                    bottom: 0;
                                    width: 16px;
                                    height: 16px;
                                    margin-top: 0;
                                    z-index: 10;
                                    cursor: pointer;
                                    background-size: 8px 17px;
                                    background-position: center;
                                    background-repeat: no-repeat;
                                  }
                                  .swiper-button-prev {
                                    left: 120px;
                                  }
                                  .swiper-button-next {
                                    right: 120px;
                                  }

                                }
                            }

                            .right {
                                /*margin-left: 10px;*/
                                /*margin-right: 10px;*/
                                /*padding-top: 20px;*/
                            }
                        }

                        .button-detail {
                            margin: 7px auto 0;
                            width: 112px;
                            height: 24px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 10px;
                            font-weight: bold;
                            color: #000000;
                            line-height: 16px;
                            background: url(~@/assets/img/page-home-button-detail-bg1.png) center center/cover no-repeat;
                            background-size: 100% 100%;
                            border-radius: 7px;
                            box-shadow: 2px 0 5px rgba(2, 42, 107, 0.18);

                            img {
                                width: 10px;
                                margin-left: 5px;
                            }
                        }
                    }

                    .list-one-padding {
                        padding-bottom: 30px;
                    }
                }

                .container-two-button {
                    margin: 6px auto 0;
                    width: 193px;
                    height: 28px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 15px;
                    color: #0976f1;
                    line-height: 28px;
                    text-decoration: underline;

                    img {
                        width: 15px;
                        margin-left: 17px;
                    }
                }
            }
        }
    }
</style>
